import { Builder } from '@builder.io/react'
import CdnImage from 'components/util/CdnImage'
import CdnVideo from 'components/util/CdnVideo'
// import CloudinaryImage from 'components/util/CloudinaryImage'
import React from 'react'
import LinkButton, { LinkButtonProp } from '../common/button'
import VideoPlayer from '../common/video-player'

import './index.css'

interface Props {
  backgroundColor: string
  backgroundImage: string
  videoHero: boolean
  videoSrc: any
  image: any
  imageAltText: string
  heroTextImgAltText: string
  buttonEnabled: boolean
  buttonProp: LinkButtonProp
  mediaBackdropColor: string
  heroTextImage: any
  cloudinaryTextImage: any
  builderTextImage: any
  builderHeroTextImage: any
  cloudinaryHeroTextImage: any
  cloudinaryVideo: any
  videoShouldLoop: boolean
  playbackSettings: 'string'
}

const HeroThree = ({
  backgroundColor,
  backgroundImage = '',
  videoHero,
  videoSrc,
  image,
  imageAltText = '',
  heroTextImgAltText = '',
  buttonEnabled,
  buttonProp,
  mediaBackdropColor,
  heroTextImage,
  cloudinaryTextImage,
  cloudinaryHeroTextImage,
  builderTextImage,
  builderHeroTextImage,
  cloudinaryVideo,
  videoShouldLoop,
  playbackSettings
}: Props) => {
  const renderImageOrVideo = () => {
    if (videoHero) {
      const cloudinaryVideoUrl = cloudinaryVideo?.secure_url?.replace('/upload', '/upload/q_auto')

      return (
        <div className="index-2 h-full max-h-96">
          {videoSrc ? (
            <CdnVideo
              videoSrc={videoSrc}
              videoLoop={videoShouldLoop}
              imageSrc={image}
              playbackSettings={playbackSettings}
              account={false}
            />
          ) : (
            <VideoPlayer
              videoLoop={videoShouldLoop}
              videoSrc={cloudinaryVideoUrl}
              playbackSettings={playbackSettings}
            />
          )}{' '}
        </div>
      )
    }

    return (
      <CdnImage
        className="index-2 relative object-cover"
        url={builderHeroTextImage}
        alt={imageAltText}
        lazyLoad={false}
        steps={[1080]}
        style={{
          width: '1080px',
          height: '100%',
          maxWidth: '100%'
        }}
      />

      // <>
      //   {builderHeroTextImage ? (
      //     <CdnImage
      //       className="index-2 relative object-cover"
      //       url={builderHeroTextImage}
      //       alt={imageAltText}
      //       lazyLoad={false}
      //       steps={[1080]}
      //       style={{
      //         width: '1080px',
      //         height: '100%',
      //         maxWidth: '100%'
      //       }}
      //     />
      //   ) : (
      //     <CloudinaryImage
      //       className="index-2 relative object-cover"
      //       publicId={cloudinaryHeroTextImage?.public_id}
      //       alt={imageAltText}
      //       loading={'eager'}
      //       steps={[1080]}
      //       style={{
      //         width: '1080px',
      //         height: '100%',
      //         maxWidth: '100%'
      //       }}
      //     />
      //   )}
      // </>
    )
  }

  const renderCTAButton = () => {
    if (buttonEnabled) {
      return (
        <LinkButton
          buttonColor={buttonProp?.buttonColor}
          buttonText={buttonProp?.buttonText}
          loggedInButtonText={buttonProp?.loggedInButtonText}
          buttonTextColor={buttonProp?.buttonTextColor}
          buttonUrl={buttonProp?.buttonUrl}
          isLink={buttonProp.isLink}
          classList={
            'mt-4 mx-auto w-full md:w-8/12 flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-full text-indigo-700 bg-indigo-100 hover:bg-indigo-200 md:text-lg'
          }
        />
      )
    }

    return null
  }

  const renderHeroTextImage = () => {
    if (builderTextImage) {
      return (
        <CdnImage
          className="h-auto"
          url={builderTextImage}
          alt={heroTextImgAltText}
          lazyLoad={false}
          steps={[550, 400]}
          style={{
            width: '490px',
            // height: '457px',
            maxHeight: '100%',
            maxWidth: '100%'
          }}
        />

        // <>
        //   {builderTextImage ? (
        //     <CdnImage
        //       url={builderTextImage}
        //       alt={heroTextImgAltText}
        //       lazyLoad={false}
        //       steps={[550, 400]}
        //       style={{
        //         width: '490px',
        //         height: '457px',
        //         maxHeight: '100%',
        //         maxWidth: '100%'
        //       }}
        //     />
        //   ) : (
        //     <CloudinaryImage
        //       publicId={cloudinaryTextImage?.public_id}
        //       alt={heroTextImgAltText}
        //       loading={'eager'}
        //       steps={[550, 400]}
        //       autoFormat={false}
        //       style={{
        //         width: '490px',
        //         height: '457px',
        //         maxHeight: '100%',
        //         maxWidth: '100%'
        //       }}
        //     />
        //   )}
        // </>
      )
    }

    return (
      <svg width="100%" height="100%" viewBox="0 0 437 303" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.47721 197H62.1262V194.812H45.9321V31.1195H3.25837V33.3079H19.6713V194.812H3.47721V197ZM131.909 199.845C166.704 199.845 190.558 174.678 190.558 142.728C190.558 111.653 168.017 84.5164 132.346 84.5164C97.3321 84.5164 73.6974 109.683 73.6974 141.415C73.6974 172.709 96.019 199.845 131.909 199.845ZM139.568 197C122.936 197 112.432 177.304 105.648 152.138C102.365 139.883 100.834 129.379 100.834 121.281C100.834 94.1453 113.307 87.3613 124.687 87.3613C141.1 87.3613 151.823 106.838 158.607 132.005C161.89 144.26 163.422 154.983 163.422 162.861C163.422 189.997 150.948 197 139.568 197ZM254.638 199.626H256.17L306.722 89.3309H321.603V87.1425H282.869V89.3309H303.877L268.644 166.362L234.505 89.3309H249.386V87.1425H190.518V89.3309H205.181L254.638 199.626ZM376.353 199.845C404.364 199.845 425.592 184.964 430.187 147.761H428.437C421.871 175.991 402.395 181.681 387.513 181.681C362.347 181.681 345.496 160.016 345.496 129.16C345.496 126.315 345.715 123.689 345.934 121.063H425.154C417.276 91.7381 394.516 84.5164 375.696 84.5164C346.59 84.5164 320.111 108.151 320.111 142.728C320.111 178.399 344.621 199.845 376.353 199.845ZM374.383 86.486C389.483 86.486 395.392 99.6163 395.392 107.276C395.392 116.029 391.89 118.655 377.666 118.655H346.153C348.998 97.4279 360.159 86.486 374.383 86.486Z"
          fill="#004355"
        />
        <path
          d="M97.255 302.374C102.135 302.374 103.9 298.739 107.119 291.471L137.231 224.914H144.187V223.876H125.913V224.914H135.881L119.268 261.671L102.862 224.914H109.923V223.876H81.9916V224.914H88.9484L112.311 276.934L107.95 286.695C95.6975 287.006 91.1289 291.99 91.1289 296.351C91.1289 299.778 93.7247 302.374 97.255 302.374ZM171.198 277.35C187.707 277.35 199.025 265.409 199.025 250.249C199.025 235.505 188.33 222.63 171.405 222.63C154.792 222.63 143.578 234.571 143.578 249.626C143.578 264.475 154.169 277.35 171.198 277.35ZM174.832 276C166.941 276 161.957 266.655 158.738 254.714C157.18 248.9 156.454 243.916 156.454 240.074C156.454 227.199 162.372 223.98 167.771 223.98C175.559 223.98 180.647 233.221 183.865 245.162C185.423 250.976 186.15 256.064 186.15 259.802C186.15 272.677 180.231 276 174.832 276ZM227.818 277.35C235.813 277.35 241.628 273.197 243.497 265.824V276H263.641V274.962H255.957V223.876H236.021V224.914H243.497V257.725C243.497 268.213 239.967 272.781 233.633 272.781C228.13 272.781 224.392 268.628 224.392 257.725V223.876H204.144V224.914H211.932V258.037C211.932 271.847 218.473 277.35 227.818 277.35Z"
          fill="#004355"
          fill-opacity="0.6"
        />
        <path
          d="M83.6854 49.1797H99.298V48.7387H93.8733V32.2881H100.092C100.621 32.2881 100.753 32.3763 101.062 32.9938L103.664 38.5067H103.929V25.6285H103.664L101.062 31.1414C100.753 31.803 100.621 31.8471 100.092 31.8471H93.8733V16.1904H103.796C104.855 16.1904 105.164 16.2786 105.693 17.0284L112.176 26.1137H112.441L110.456 15.7494H83.6854V16.1904H87.9193V48.7387H83.6854V49.1797ZM123.885 49.753C130.897 49.753 135.705 44.6812 135.705 38.2421C135.705 31.9794 131.162 26.5106 123.973 26.5106C116.917 26.5106 112.153 31.5825 112.153 37.9775C112.153 44.2842 116.652 49.753 123.885 49.753ZM125.428 49.1797C122.077 49.1797 119.96 45.2104 118.592 40.1385C117.931 37.6687 117.622 35.5518 117.622 33.92C117.622 28.4511 120.136 27.0839 122.429 27.0839C125.737 27.0839 127.898 31.0091 129.265 36.081C129.927 38.5508 130.236 40.7119 130.236 42.2996C130.236 47.7684 127.722 49.1797 125.428 49.1797ZM150.889 49.753C157.902 49.753 162.709 44.6812 162.709 38.2421C162.709 31.9794 158.167 26.5106 150.978 26.5106C143.921 26.5106 139.158 31.5825 139.158 37.9775C139.158 44.2842 143.657 49.753 150.889 49.753ZM152.433 49.1797C149.081 49.1797 146.964 45.2104 145.597 40.1385C144.936 37.6687 144.627 35.5518 144.627 33.92C144.627 28.4511 147.141 27.0839 149.434 27.0839C152.742 27.0839 154.903 31.0091 156.27 36.081C156.932 38.5508 157.24 40.7119 157.24 42.2996C157.24 47.7684 154.726 49.1797 152.433 49.1797ZM175.998 49.753C179.129 49.753 181.467 48.033 182.701 45.5632V49.1797H191.257V48.7387H187.994V15.7494H178.423V16.1904H182.701V30.1712C181.643 28.0542 179.217 26.5106 176.395 26.5106C171.279 26.5106 166.251 30.965 166.251 38.1539C166.251 45.7396 171.279 49.753 175.998 49.753ZM178.6 47.7243C175.072 47.7243 172.381 44.1519 172.381 37.801C172.381 31.1414 175.513 28.2747 178.512 28.2747C180.32 28.2747 182.128 29.245 182.701 31.0532V44.6812C182.084 46.4012 180.496 47.7243 178.6 47.7243ZM213.605 43.1375V29.7301H220.177L222.338 27.0398H213.605V22.0121H213.429L203.726 29.5096V29.7301H208.313V44.2401C208.313 48.7828 210.827 49.5766 213.694 49.5766C216.781 49.5766 219.648 47.9448 221.235 46.1807L221.015 45.916C220.044 46.7099 218.501 47.2391 217.222 47.2391C215.061 47.2391 213.605 46.2689 213.605 43.1375ZM222.171 49.1797H233.991V48.7387H230.727V34.8461C230.727 30.3917 232.271 28.4511 235.05 28.4511C237.475 28.4511 239.107 30.2153 239.107 34.8461V48.7387H235.843V49.1797H247.663V48.7387H244.399V34.7138C244.399 28.8481 241.621 26.5106 237.608 26.5106C234.256 26.5106 231.61 28.0983 230.727 31.4943V15.7494H222.127V16.1904H225.435V48.7387H222.171V49.1797ZM256.948 49.753C259.77 49.753 262.196 48.033 263.034 44.9899L263.254 49.1797H271.546V48.7387H268.282L268.326 33.1702C268.326 27.4809 265.063 26.3783 261.578 26.3783C258.006 26.3783 255.58 27.8337 253.155 29.4214C251.479 30.4799 249.935 31.6266 249.935 33.1702C249.935 34.4492 251.435 35.243 253.155 35.243C253.86 35.243 254.831 34.9784 255.36 34.4933C254.522 28.9804 256.462 27.2163 259.109 27.2163C261.27 27.2163 263.078 28.8922 263.078 32.0676C263.078 33.523 262.549 34.4051 261.446 35.2872C260.608 35.9487 259.461 36.6544 258.006 37.3159C253.463 39.477 250.067 40.0062 250.067 43.8432C250.067 47.2391 253.199 49.753 256.948 49.753ZM259.55 47.6802C257.477 47.6802 255.801 45.4309 255.801 42.476C255.801 39.3447 258.844 37.6687 261.358 35.8605C262.019 35.3754 262.593 34.8902 263.078 34.361L262.99 43.0493C262.946 45.9601 261.27 47.6802 259.55 47.6802ZM282.129 43.1375V29.7301H288.701L290.862 27.0398H282.129V22.0121H281.953L272.25 29.5096V29.7301H276.837V44.2401C276.837 48.7828 279.351 49.5766 282.217 49.5766C285.305 49.5766 288.171 47.9448 289.759 46.1807L289.538 45.916C288.568 46.7099 287.025 47.2391 285.746 47.2391C283.585 47.2391 282.129 46.2689 282.129 43.1375ZM311.717 49.753C317.406 49.753 321.199 46.8863 321.199 42.5642C321.199 38.8154 318.421 36.5661 314.054 35.5077L311.364 34.8461C309.071 34.2728 307.483 32.8174 307.483 30.524C307.483 27.7896 309.953 26.9516 312.07 26.9516C313.172 26.9516 313.834 27.0398 314.231 27.5691L319.832 35.1548H320.097L318.818 27.3927C316.789 26.8193 314.804 26.5106 312.82 26.5106C308.1 26.5106 303.999 28.9363 303.999 33.2584C303.999 36.5661 306.38 39.1241 310.217 40.0503L312.952 40.7119C315.598 41.3734 317.406 42.6965 317.406 45.1663C317.406 48.033 314.716 49.3561 312.026 49.3561C310.835 49.3561 310.129 49.2238 309.644 48.474L304.219 40.0062H303.911L305.146 48.9151C307.174 49.4884 309.556 49.753 311.717 49.753ZM331.803 49.753C334.625 49.753 337.051 48.033 337.889 44.9899L338.109 49.1797H346.401V48.7387H343.137L343.181 33.1702C343.181 27.4809 339.918 26.3783 336.433 26.3783C332.861 26.3783 330.435 27.8337 328.01 29.4214C326.334 30.4799 324.79 31.6266 324.79 33.1702C324.79 34.4492 326.29 35.243 328.01 35.243C328.715 35.243 329.686 34.9784 330.215 34.4933C329.377 28.9804 331.317 27.2163 333.964 27.2163C336.125 27.2163 337.933 28.8922 337.933 32.0676C337.933 33.523 337.404 34.4051 336.301 35.2872C335.463 35.9487 334.316 36.6544 332.861 37.3159C328.318 39.477 324.922 40.0062 324.922 43.8432C324.922 47.2391 328.054 49.753 331.803 49.753ZM334.405 47.6802C332.332 47.6802 330.656 45.4309 330.656 42.476C330.656 39.3447 333.699 37.6687 336.213 35.8605C336.874 35.3754 337.448 34.8902 337.933 34.361L337.845 43.0493C337.801 45.9601 336.125 47.6802 334.405 47.6802ZM352.015 60.3819C354.088 60.3819 354.838 58.8383 356.205 55.7511L368.995 27.4809H371.95V27.0398H364.187V27.4809H368.421L361.365 43.0934L354.397 27.4809H357.396V27.0398H345.532V27.4809H348.487L358.41 49.5766L356.558 53.7223C351.353 53.8546 349.413 55.9716 349.413 57.8239C349.413 59.2793 350.515 60.3819 352.015 60.3819ZM380.284 49.753C385.973 49.753 389.766 46.8863 389.766 42.5642C389.766 38.8154 386.987 36.5661 382.621 35.5077L379.931 34.8461C377.638 34.2728 376.05 32.8174 376.05 30.524C376.05 27.7896 378.52 26.9516 380.637 26.9516C381.739 26.9516 382.401 27.0398 382.798 27.5691L388.399 35.1548H388.663L387.384 27.3927C385.356 26.8193 383.371 26.5106 381.386 26.5106C376.667 26.5106 372.566 28.9363 372.566 33.2584C372.566 36.5661 374.947 39.1241 378.784 40.0503L381.519 40.7119C384.165 41.3734 385.973 42.6965 385.973 45.1663C385.973 48.033 383.283 49.3561 380.592 49.3561C379.402 49.3561 378.696 49.2238 378.211 48.474L372.786 40.0062H372.477L373.712 48.9151C375.741 49.4884 378.123 49.753 380.284 49.753ZM419.362 48.7387H415.173V16.1904H419.362V15.7494H404.985V16.1904H409.219V48.7387H404.985V49.1797H419.362V48.7387Z"
          fill="#004355"
        />
      </svg>
    )
  }

  return (
    <div
      className="bg-image-none relative w-full md:bg-cover md:bg-bottom md:bg-no-repeat lg:-mt-12 lg:pt-12"
      style={{ backgroundColor, backgroundImage: backgroundImage ? `url(${backgroundImage ?? ''})` : 'none' }}
    >
      {/* <div className="bg-svg-wrapper">
        <svg width="100%" height="100%" viewBox="0 0 1440 1015" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M25.4095 146.462C-265.211 117.041 -441.955 246.878 -494 315.475V1015H1639V146.462C1521.43 85.6902 1204.94 -35.0702 879.48 -31.9403C472.661 -28.028 388.685 183.238 25.4095 146.462Z" fill="#F6E9DB"/>
        </svg>
      </div> */}

      <main className="container mx-auto md:flex">
        <div className="mt-8 h-full md:w-5/12">
          <div className="mx-auto flex h-full w-11/12 flex-col justify-center p-10 sm:w-4/5 md:p-0">
            {renderHeroTextImage()}
            {renderCTAButton()}
          </div>
        </div>
        <div className="py-8 md:w-7/12">
          <div className="height-specifier relative ml-5 h-full w-11/12 rounded-lg shadow-lg sm:mx-auto sm:w-3/4">
            <div
              className="video-backdrop-square-wrapper absolute h-full w-full"
              style={{ backgroundColor: mediaBackdropColor }}
            />
            {renderImageOrVideo()}
          </div>
        </div>
      </main>
    </div>
  )
}

export default HeroThree

// export const pageQuery = graphql`
//   query HeroThreeImageQuery {
//     allImageSharp(fixed: { src: { eq: $image } } ) {
//       edges {
//         node {
//           fixed {
//             src
//           }
//         }
//       }
//     }
//   }
// `
